import { initializeApp } from 'firebase/app';
import { getAuth, setPersistence, browserSessionPersistence } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore'; // ✅ Ye already hai
import { getMessaging } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyD5H30OecsDDQBhgwGe0vxI3SocW-pf85k",
  authDomain: "phixxcore.firebaseapp.com",
  projectId: "phixxcore",
  storageBucket: "phixxcore.firebasestorage.app",
  messagingSenderId: "877041896576",
  appId: "1:877041896576:web:ee2ef076efeeb345d9ea65",
  measurementId: "G-6KT2EGW8J2"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app); // ✅ Ye already exported hai
export const messaging = getMessaging(app);
// Session persistence setup - NO LOCAL STORAGE
setPersistence(auth, browserSessionPersistence);

export default app;